import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex flex-col gap-4 overflow-hidden"
};
const _hoisted_2 = {
  class: "flex flex-col gap-3 border-b border-white/50 pb-3"
};
const _hoisted_3 = {
  class: "w-full flex flex-wrap items-center justify-between gap-2"
};
const _hoisted_4 = {
  class: "flex gap-2"
};
const _hoisted_5 = {
  class: "flex items-center gap-3 ml-auto"
};
const _hoisted_6 = {
  class: "flex items-center gap-2 justify-between"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "w-full flex flex-col gap-6 overflow-y-auto scroll pr-0.5 pb-6"
};
const _hoisted_9 = {
  class: "w-[750px] flex flex-col gap-6"
};
const _hoisted_10 = {
  class: "text-xl font-bold text-center"
};
const _hoisted_11 = {
  class: "flex flex-col gap-3 overflow-y-auto scroll-main pr-1 py-0.5"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "flex items-center gap-3 grow"
};
const _hoisted_14 = {
  class: "w-[750px] flex flex-col gap-6"
};
const _hoisted_15 = {
  class: "text-xl font-bold text-center"
};
const _hoisted_16 = {
  class: "flex flex-col gap-3 overflow-y-auto scroll-main pr-1 py-0.5"
};
const _hoisted_17 = {
  class: "font-medium"
};
const _hoisted_18 = {
  class: "w-full max-w-[400px]"
};
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col gap-1"
};
const _hoisted_20 = {
  class: "flex items-center gap-1"
};
const _hoisted_21 = {
  key: 4
};
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-2 p-1 pl-2 rounded bg-second-10"
};
const _hoisted_23 = ["title"];
const _hoisted_24 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompanyConfig = _resolveComponent("CompanyConfig");
  const _component_Button = _resolveComponent("Button");
  const _component_Dropdown = _resolveComponent("Dropdown");
  const _component_SubmissionsList = _resolveComponent("SubmissionsList");
  const _component_DefaultView = _resolveComponent("DefaultView");
  const _component_ScrollShadow = _resolveComponent("ScrollShadow");
  const _component_Modal = _resolveComponent("Modal");
                                                      
                                                                    
  const _component_s_infotooltip = _resolveComponent("s-infotooltip");
  const _component_s_model_value_adapter = _resolveComponent("s-model-value-adapter");
                                                            
                                                                
  const _component_SelectionDialog = _resolveComponent("SelectionDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_DefaultView, null, {
    default: _withCtx(() => [_createVNode(_Transition, {
      name: this.viewConfig.view === 'configuration' ? 'slide-forward' : 'slide-back'
    }, {
      default: _withCtx(() => [this.viewConfig.view === 'configuration' ? (_openBlock(), _createBlock(_component_CompanyConfig, {
        key: 0,
        onclose: () => this.viewConfig.view = 'dashboard',
        viewConfig: this.viewConfig
      }, null, 8, ["onclose", "viewConfig"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "text-lg font-medium"
      }, "Altas  |  Historial y Pendientes", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Button, {
        variant: "outlined_light",
        size: "sm",
        text: "Configuración de empresas y grupos",
        icon: "icon-gear",
        onClick: _cache[0] || (_cache[0] = $event => this.viewConfig.view = 'configuration')
      }), _createVNode(_component_Button, {
        variant: "outlined_light",
        size: "sm",
        text: "Configuración de formulario",
        icon: "icon-form",
        onClick: _cache[1] || (_cache[1] = $event => this.ManageFormToFlowConfiguration())
      }), this.viewConfig.formToFlow?.instructionsURL ? (_openBlock(), _createBlock(_component_Button, {
        key: 0,
        variant: "outlined_light",
        size: "sm",
        icon: "icon-eye-open",
        text: "Instrucciones",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$openExternal(this.viewConfig.formToFlow.instructionsURL))
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_Button, {
        variant: "outlined_light",
        size: "sm",
        text: "",
        icon: "icon-refresh",
        onClick: this.Init
      }, null, 8, ["onClick"]), _createVNode(_component_Button, {
        variant: "outlined_light",
        size: "sm",
        text: "Nueva Alta",
        icon: "",
        onClick: _cache[3] || (_cache[3] = $event => $options.HandleSubmissionModal(false))
      }), _createVNode(_component_Button, {
        text: "Sincronizar con A3",
        size: "sm",
        class: "secondary",
        icon: "link-trash",
        loading: _ctx.viewConfig.loading.running,
        onClick: this.OnSubmissionSyncWithA3
      }, null, 8, ["loading", "onClick"]), _createVNode(_component_Button, {
        variant: "primary",
        size: "sm",
        text: "Altas Automáticas S. RED",
        loading: _ctx.viewConfig.loading.running,
        onClick: _cache[4] || (_cache[4] = $event => this.OnSubmissionsLaunch())
      }, null, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_Dropdown, {
        size: "sm",
        items: $options.filterByCompanyDropdownItems,
        floating: true,
        modelValue: _ctx.filterByCompany,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.filterByCompany = $event),
        class: "max-w-sm"
      }, null, 8, ["items", "modelValue"])]), this.viewConfig.loading.submissions ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[7] || (_cache[7] = [_createElementVNode("div", {
        class: "h-12 w-12 loading-spinner-main mx-auto"
      }, null, -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_SubmissionsList, {
        data: {
          label: 'Pendientes',
          items: this.SubmissionsByType.pendings,
          trashCallback: this.RemoveSelectedSubmissions,
          openSubmissionCallback: submission => this.HandleSubmissionModal(true, submission)
        }
      }, null, 8, ["data"]), this.SubmissionsByType.historial?.length ? (_openBlock(), _createBlock(_component_SubmissionsList, {
        key: 0,
        data: {
          label: 'Historial',
          items: this.SubmissionsByType.historial,
          trashCallback: this.RemoveSelectedSubmissions,
          openSubmissionCallback: submission => this.HandleSubmissionModal(true, submission)
        }
      }, null, 8, ["data"])) : _createCommentVNode("", true)]))]))]),
      _: 1
    }, 8, ["name"])]),
    _: 1
  }), !_ctx.viewConfig.modal && _ctx.viewConfig.copiedGroup ? (_openBlock(), _createBlock(_component_Modal, {
    key: 0,
    onclose: () => {
      this.DeleteCopyGroup();
    },
    footer: [{
      variant: 'outlined',
      text: _ctx.$st('general.cancel'),
      click: () => {
        this.DeleteCopyGroup();
      }
    }]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, "Copiar grupo: " + _toDisplayString(_ctx.viewConfig.copiedGroup.nombrePerfil) + " - " + _toDisplayString(_ctx.viewConfig.copiedGroupCompanyName), 1), _cache[9] || (_cache[9] = _createElementVNode("p", null, "Selecciona la empresa donde quieres copiar el grupo", -1)), _createVNode(_component_ScrollShadow, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredClients, company => {
        return _openBlock(), _createElementBlock("div", {
          key: company,
          class: "flex items-center justify-between gap-2"
        }, [_createElementVNode("div", {
          class: "group h-12 flex w-full items-center bg-main-5 hover:bg-second-10 text-main-100 rounded-md shadow-weak_material cursor-pointer *:px-5",
          onClick: $event => this.PasteGroup(company)
        }, [_createElementVNode("p", _hoisted_13, [_cache[8] || (_cache[8] = _createElementVNode("i", {
          class: "icon-certificate text-xl"
        }, null, -1)), _createElementVNode("span", null, _toDisplayString(company.fieldsValues.nombreEmpresa), 1)])], 8, _hoisted_12)]);
      }), 128))])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["onclose", "footer"])) : _createCommentVNode("", true), _ctx.viewConfig.modal ? (_openBlock(), _createBlock(_component_Modal, {
    key: 1,
    onclose: () => {
      this.CleanInputs();
      _ctx.viewConfig.modal = undefined;
    },
    footer: [{
      variant: 'outlined',
      text: _ctx.$st('general.cancel'),
      click: () => {
        $options.CleanInputs();
        _ctx.viewConfig.modal = undefined;
      }
    }, {
      variant: 'primary',
      text: _ctx.viewConfig.modal.saveButtonText,
      click: _ctx.viewConfig.modal.saveButtonClick
    }]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.viewConfig.modal.title), 1), _createVNode(_component_ScrollShadow, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewConfig.modal.fields, field => {
        return _openBlock(), _createElementBlock("div", {
          key: field,
          class: "flex items-center justify-between gap-2"
        }, [_createElementVNode("p", _hoisted_17, _toDisplayString(field.title + (field.required ? ' *' : '')), 1), _createElementVNode("div", _hoisted_18, [_ctx.viewConfig.modal.isClient && field.multiKeyValue ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.value, (multi, index) => {
          return _openBlock(), _createBlock(_component_s_infotooltip, {
            key: multi,
            validation: {
              validate: () => $options.ValidateMultiKeyValue(multi)
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_v_btn, {
              icon: "icon-trash",
              variant: "plain",
              size: "x-small",
              onClick: $event => field.value.length > 1 ? field.value.splice(index, 1) : field.value[index] = {
                key: '',
                text: ''
              }
            }, null, 8, ["onClick"]), _createVNode(_component_v_text_field, {
              size: "sm",
              modelValue: multi.text,
              "onUpdate:modelValue": $event => multi.text = $event,
              "hide-details": "",
              variant: "outlined",
              density: "compact",
              placeholder: "Etiqueta",
              class: "w-full shrink-[1.5]",
              required: field.required
            }, null, 8, ["modelValue", "onUpdate:modelValue", "required"]), _createVNode(_component_v_text_field, {
              size: "sm",
              modelValue: multi.key,
              "onUpdate:modelValue": $event => multi.key = $event,
              "hide-details": "",
              variant: "outlined",
              density: "compact",
              placeholder: field.title,
              class: "w-full",
              required: field.required
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "required"]), _createVNode(_component_v_btn, {
              icon: "icon-plus",
              variant: "plain",
              size: "x-small",
              onClick: $event => field.value.push({
                key: '',
                text: ''
              })
            }, null, 8, ["onClick"])])]),
            _: 2
          }, 1032, ["validation"]);
        }), 128))])) : field.fieldType === 'text' || field.fieldType === 'date' ? (_openBlock(), _createBlock(_component_s_infotooltip, {
          key: 1,
          validation: {
            required: field.required,
            format: true,
            type: field.fieldType,
            subtype: field.validate
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_s_model_value_adapter, {
            modelValue: field.value,
            "onUpdate:modelValue": $event => field.value = $event,
            type: field.fieldType
          }, {
            default: _withCtx(() => [_createVNode(_component_v_text_field, {
              size: "sm",
              type: field.fieldType,
              "hide-details": "",
              variant: "outlined",
              density: "compact",
              placeholder: "Escribe aquí"
            }, null, 8, ["type"])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "type"])]),
          _: 2
        }, 1032, ["validation"])) : field.fieldType === 'dropdown' ? (_openBlock(), _createBlock(_component_s_infotooltip, {
          key: 2,
          validation: {
            required: field.required
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_v_select, {
            class: "w-full",
            placeholder: "Selecciona una opción",
            items: field.validValues,
            "item-title": "text",
            "item-value": "key",
            multiple: false,
            "hide-details": "",
            variant: "outlined",
            density: "compact",
            modelValue: field.value,
            "onUpdate:modelValue": $event => field.value = $event
          }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])]),
          _: 2
        }, 1032, ["validation"])) : field.fieldType === 'checkbox' ? (_openBlock(), _createBlock(_component_v_checkbox, {
          key: 3,
          modelValue: field.value,
          "onUpdate:modelValue": $event => field.value = $event,
          density: "compact",
          "hide-details": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : field.fieldType === 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [field.value.logo ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[10] || (_cache[10] = _createElementVNode("i", {
          class: "icon-image-icon"
        }, null, -1)), _createElementVNode("p", {
          class: "w-full truncate text-xs",
          title: field.value.logo.name
        }, _toDisplayString(field.value.logo.name), 9, _hoisted_23), _createElementVNode("i", {
          class: "icon-cross text-2xs cursor-pointer button-hover",
          onClick: $event => field.value.logo = undefined
        }, null, 8, _hoisted_24)])) : !field.value.logo ? (_openBlock(), _createBlock(_component_SelectionDialog, _mergeProps({
          key: 1,
          embedded: false,
          ref_for: true
        }, field, {
          modelValue: field.value.newlogo,
          "onUpdate:modelValue": $event => field.value.newlogo = $event,
          required: field.required
        }), null, 16, ["modelValue", "onUpdate:modelValue", "required"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
      }), 128))])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["onclose", "footer"])) : _createCommentVNode("", true)], 64);
}

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"
import { VCheckbox as _component_v_checkbox } from "vuetify/components/VCheckbox"
import { VSelect as _component_v_select } from "vuetify/components/VSelect"
import { VTextField as _component_v_text_field } from "vuetify/components/VTextField"

